// Steps for homepage
const onboardingChecklistSteps = [
{
    element: ".table-responsive",
    popover: {
        className: 'first-step-popover-class',
        Title: "🙋<br>Let' start",
        description: '<b>On this page you can find an overview of all internal tasks to be processed in the pre-boarding and onboarding of employees.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".edit",
    popover: {
        className: 'image-popover',
        title: '<a href="../onboarding?profile=12" target="_blank" title="Více"><img src="/images/guide-onboarding-1.png"></a>',
        description: 'Tasks are uploaded automatically to this page, you just have to select them for each employee. By clicking on the icon <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg> you can view the employee which the task was assigned to. 👌',
        position: 'bottom-right',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        className: 'image-popover',
        title: '<a href="/onboarding/stranka?id=1&job=1#guide" target="_blank" title="Více"><img src="/images/guide-onboarding-3.png"></a>',
        description: '<b>Get acquaint with the boarding from the point of view of your employees (1 min).</b><br><br> In a simple editor you can prepare a page that will be displayed to your employees <b>at a selected time</b> (before onboarding, on the first day etc.) who occupy the selected job.<br> You can add content according to your preferences or you can use our ready-made templates.',
        position: 'right-center',
        showButtons: true,
        doneBtnText: 'Yes, carry on',
        nextBtnText: 'Understood',        // Next button text for this step
        prevBtnText: 'Back',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding/stranka?id=1&job=1#guide");

    }


},
]



export default onboardingChecklistSteps
